import { render, staticRenderFns } from "./ArtLinkEdit.vue?vue&type=template&id=0c8976d2&scoped=true&"
import script from "./ArtLinkEdit.vue?vue&type=script&lang=js&"
export * from "./ArtLinkEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8976d2",
  null
  
)

export default component.exports